import React, { Component } from "react";
import Breadcrumb from "../components/breadcrumb/breadcrumb";

const withBreadCrumb = (WrappedComponent, options = {}) => {
  class HOC extends Component {
    render() {
      return (
        <div className={options.className}>
          <Breadcrumb {...options} />
          <WrappedComponent {...this.props} breadcrumb={options} />
        </div>
      );
    }
  }
  return HOC;
};

export default withBreadCrumb;
